<template>
  <el-dialog
    v-model="visible"
    :title="dialogTitle"
    :width="800"
    @close="handleClose"
    destroy-on-close
    class="custom-dialog"
    top="5vh"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="110px" :disabled="isView" style="padding-right: 10px;height: 78vh;overflow: hidden;">
      <!-- 分类名称 -->
      <el-form-item label="分类名称" prop="catName">
        <el-input v-model="form.catName" placeholder="请输入分类名称" style="width: 280px" maxlength="8" />
      </el-form-item>

      <!-- 分类下商品 -->

      <!-- 上架后状态 -->
      <el-form-item label="上架后状态" prop="catStatus">
        <el-radio-group v-model="form.showStatus">
          <el-radio label="show">立即显示</el-radio>
          <el-radio label="hide">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分类下商品" prop="bindCatSpuList">
        <div style="width: 100%">
          <el-button type="primary" @click="openGoodsDialog" style="margin-bottom: 10px">
            <el-icon style="margin-right: 5px"><Plus /></el-icon>
            添加商品
          </el-button>

          <!--
            修改：去掉了 max-height="350"
            理由：CSS中已经让 .el-dialog__body 滚动了，这里让表格自动撑高即可，
            避免出现双重滚动条，用户体验更好。
          -->
          <el-table
            :data="selectedSpuList"
            border
            size="small"
            style="width: 100%"
            row-key="spuCode"
          >
            <el-table-column label="商品名称" prop="spuName" min-width="150" show-overflow-tooltip />
            <el-table-column label="商品编码" prop="spuCode" width="180" show-overflow-tooltip />
            <el-table-column label="操作" width="80" align="center" fixed="right">
              <template #default="{ $index, row }">
                <el-button link type="danger" @click="removeSpu($index,row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="tip-text">共 {{ selectedSpuList.length }} 个商品，会根据表格顺序进行初始排序</div>
        </div>
      </el-form-item>

    </el-form>

    <template #footer v-if="!isView">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
    </template>

    <!-- 引入商品选择弹窗组件 -->
    <ProductDialog
      v-if="goodsDialogVisible"
      v-model:visible="goodsDialogVisible"
      @confirm="handleSelectGoods"
      withoutCat
    />
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, computed, reactive, watch } from 'vue'
import { ElMessage, type FormInstance } from 'element-plus'
import { Plus } from '@element-plus/icons-vue'
import ProductDialog from "@/components/activity/ProductDialog.vue";
import {useCurrentAppInstance} from "@zto/zpage-runtime";

type DialogType = 'ADD' | 'EDIT' | 'VIEW'

const props = defineProps<{
  apiSubmit?: (data: any) => Promise<any>
}>()
const emit = defineEmits(['refresh'])
const app = useCurrentAppInstance()
// --- 状态 ---
const visible = ref(false)
const mode = ref<DialogType>('ADD')
const submitting = ref(false)
const formRef = ref<FormInstance>()

const goodsDialogVisible = ref(false)
const selectedSpuList = ref<any[]>([])

const form = reactive({
  id: '',
  catName: '',
  bindCatSpuList: [] as string[],
  catStatus: 'grounding',
  showStatus: 'show'
})

const rules = {
  catName: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
  bindCatSpuList: [{ type: 'array', required: false, message: '请选择至少一个商品', trigger: 'change' }],
  catStatus: [{ required: true, message: '请选择状态', trigger: 'change' }]
}

const isView = computed(() => mode.value === 'VIEW')
const dialogTitle = computed(() => ({ ADD: '新增分类', EDIT: '编辑分类', VIEW: '查看分类' }[mode.value]))

// 监听 selectedSpuList 变化，同步更新 form ID数组
watch(() => selectedSpuList.value, (newVal) => {
  form.bindCatSpuList = newVal.map(item => item.spuCode)
}, { deep: true })

const openGoodsDialog = () => {
  goodsDialogVisible.value = true
}

/**
 * 修改点 2: 修复数据选中逻辑
 */
const handleSelectGoods = async (rows: any[]) => {
  console.log('子组件传回的数据:', rows) // 调试：F12查看这里打印的数据结构是否包含 spuName 和 spuCode

  if (!rows || rows.length === 0) return

  const currentCodes = new Set(selectedSpuList.value.map(item => item.spuCode))
  // 过滤掉已经存在的商品
  const newItems = rows.filter(item => !currentCodes.has(item.spuCode))

  if (newItems.length === 0) {
    ElMessage.warning('所选商品已在列表中')
    return
  }

  // 关键：使用解构赋值 [...old, ...new] 触发 Vue 的响应式更新
  selectedSpuList.value = [...selectedSpuList.value, ...newItems]
  for (let i=0;i<newItems.length;i++){
    const item = newItems[i]
    await app.request({
      api: 'admin/goods/bindCat',
      method: 'POST',
      data: {
        spuCode: item.spuCode,
        catCode: form.catCode,
        catName: form.catName
      }
    })
  }
  ElMessage.success(`已添加 ${newItems.length} 个商品`)
  emit('refresh')
}

const removeSpu = async (index: number,row:any) => {
  selectedSpuList.value.splice(index, 1)
  // 触发一次赋值，确保某些情况下表格刷新
  selectedSpuList.value = [...selectedSpuList.value]

  await app.request({
    api: 'admin/goods/unbindCat',
    method: 'POST',
    data: {
      spuCode: row.spuCode,
      catCode: row.catCode,
      catName: row.catName
    }
  })

  emit('refresh')
}

const open = async (type: DialogType, data?: any) => {
  mode.value = type
  visible.value = true

  // 初始化表单
  Object.assign(form, {
    id: data?.id || '',
    catName: data?.catName || '',
    catStatus: data?.catShowStatus || 'grounding',
    showStatus: data?.catShowStatus,
    catCode: data?.catCode || ''
  })

  // 初始化商品列表
  selectedSpuList.value = []
  if (data?.spuInfoVOList) {
    selectedSpuList.value = [...data.spuInfoVOList]
    form.bindCatSpuList = data.spuInfoVOList.map((s: any) => s.spuCode)
  } else {
    form.bindCatSpuList = []
  }
}

const handleSubmit = async () => {
  if (!formRef.value) return
  await formRef.value.validate(async valid => {
    if (valid) {
      submitting.value = true
      try {
        const payload = {
          id: form.id,
          catName: form.catName,
          showStatus: form?.showStatus,
          catCode: form.catCode,
          catStatus:'grounding',
          bindCatSpuList: selectedSpuList.value.map((item, index) => ({
            spuCode: item.spuCode,
            sort: index + 1
          }))
        }
        if (props.apiSubmit) await props.apiSubmit(payload)
        ElMessage.success('保存成功')
        visible.value = false
        emit('refresh')
      } finally {
        submitting.value = false
      }
    }
  })
}

const handleClose = () => {
  formRef.value?.resetFields()
  selectedSpuList.value = []
}

defineExpose({ open })
</script>

<style scoped>
.tip-text {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

/*
 修改点 3: CSS 样式优化
 1. 使用 max-height 而不是 height
 2. 只有当内容非常长超过屏幕时，才在弹窗 body 里出现滚动条
*/
/* 修改点 3: CSS 样式优化 - 完美解决高度溢出问题 */
:deep(.custom-dialog) {
  display: flex;           /* 开启 Flex 布局 */
  flex-direction: column;  /* 垂直排列 */
  margin-top: 5vh !important; /* 保持顶部距离 */
  overflow: hidden;        /* 隐藏弹窗外层的滚动条 */
}

:deep(.custom-dialog .el-dialog__body) {
  flex: 1;                 /* Body 区域自动占据剩余空间 */
  overflow-y: auto;        /* 内容超出时 Body 内部滚动 */
  min-height: 0;           /* 关键：防止 Flex 子元素溢出 */
  padding: 20px;           /* 保持内边距 */
}

/* 可选：美化滚动条 */
:deep(.custom-dialog .el-dialog__body::-webkit-scrollbar) {
  width: 6px;
}
:deep(.custom-dialog .el-dialog__body::-webkit-scrollbar-thumb) {
  background: #c0c4cc;
  border-radius: 3px;
}

</style>
